import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a bathroom vanity unit 0.6 x 0.45 x 0.8 m: warm-white
// cabinet with two door fronts, grey worktop, a porcelain basin block inset on
// top and a small steel L-shaped faucet at the back. Back flush at z = -0.225.
const CABINET = "#efece6";
const WORKTOP = "#d8d5cf";
const PORCELAIN = "#f2f0ea";
const STEEL = "#aab2b8";
const MATTE_BLACK = "#2e2e30";

export const bathroomSink = defineModel({
  id: "bathroom-sink",
  batchId: "modern",
  name: "Bathroom sink",
  tags: ["modern", "interior", "fixture", "bathroom", "sink", "storage"],
  summary: "A bathroom vanity unit with a porcelain basin and steel faucet.",
  tiles: { w: 1, h: 1 },
  footprint: 0.6,
  parts(): Part[] {
    return [
      // recessed plinth
      { geometry: new THREE.BoxGeometry(0.54, 0.08, 0.34), color: MATTE_BLACK, position: [0, 0.04, -0.03] },
      // cabinet carcass (back flush at z = -0.225)
      { geometry: new THREE.BoxGeometry(0.6, 0.68, 0.41), color: CABINET, position: [0, 0.42, -0.02] },
      // two door fronts
      { geometry: new THREE.BoxGeometry(0.27, 0.62, 0.02), color: CABINET, position: [-0.145, 0.43, 0.195] },
      { geometry: new THREE.BoxGeometry(0.27, 0.62, 0.02), color: CABINET, position: [0.145, 0.43, 0.195] },
      // bar handles
      { geometry: new THREE.BoxGeometry(0.12, 0.02, 0.02), color: MATTE_BLACK, position: [-0.145, 0.68, 0.215] },
      { geometry: new THREE.BoxGeometry(0.12, 0.02, 0.02), color: MATTE_BLACK, position: [0.145, 0.68, 0.215] },
      // worktop (top surface at 0.8)
      { geometry: new THREE.BoxGeometry(0.6, 0.04, 0.45), color: WORKTOP, position: [0, 0.78, 0] },
      // porcelain basin block inset on top
      { geometry: new THREE.BoxGeometry(0.42, 0.1, 0.3), color: PORCELAIN, position: [0, 0.85, 0.02] },
      // faucet riser (steel L at the back of the worktop)
      { geometry: new THREE.BoxGeometry(0.03, 0.2, 0.03), color: STEEL, position: [0, 0.9, -0.18] },
      // faucet spout reaching over the basin
      { geometry: new THREE.BoxGeometry(0.03, 0.03, 0.14), color: STEEL, position: [0, 0.985, -0.11] },
    ];
  },
  animations: [],
});
